import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { Button } from 'ant-design-vue';
import { buttonProps, type ButtonType } from './button';
import type { PropType, ComputedRef } from 'vue';
import type { ButtonType as AButtonType } from 'ant-design-vue/es/button';


export default /*@__PURE__*/_defineComponent({
  __name: 'button',
  props: {
  ...buttonProps(),
  type: {
    type: String as PropType<ButtonType>,
    default: 'default',
  },
},
  setup(__props) {

const props = __props;

const buttonTypes = ['default', 'primary', 'ghost', 'dashed', 'link', 'text'];
const buttonType = computed(() => {
  const type = props.type;
  return buttonTypes.includes(type)
    ? (type as ButtonType)
    : ['danger'].includes(type)
      ? 'primary'
      : 'default';
}) as ComputedRef<AButtonType>;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), _mergeProps(props, {
    danger: ['danger'].includes(__props.type),
    type: buttonType.value,
    class: [`ant-btn-${__props.type}`]
  }), _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (_, key) => {
      return {
        name: key,
        fn: _withCtx(() => [
          _renderSlot(_ctx.$slots, key)
        ])
      }
    })
  ]), 1040, ["danger", "type", "class"]))
}
}

})